import { useEffect, useRef } from 'react';
import type { Swiper } from 'swiper';

import { prefersReducedMotion } from '@utils/device';

import { useMediaQuery } from './useMediaQuery';

export const useSwiperMotionPreference = () => {
	const isReducedMotionPreferred = useMediaQuery(prefersReducedMotion);
	const swiperInstance = useRef<Swiper | null>(null);
	const swiperMotionConfig = {
		speed: isReducedMotionPreferred ? 0 : 800,
	};

	useEffect(() => {
		if (swiperInstance.current?.destroyed) {
			return;
		}

		if (isReducedMotionPreferred) {
			swiperInstance.current?.autoplay.stop();
		} else {
			swiperInstance.current?.autoplay.start();
		}
	}, [isReducedMotionPreferred]);

	const onSwiper = (swiper: Swiper) => {
		swiperInstance.current = swiper;
	};

	return {
		swiperMotionConfig,
		onSwiper,
	};
};
